import(/* webpackMode: "eager" */ "/home/runner/work/yegnaweb/yegnaweb/src/app/terms/page.tsx")